import { Link } from "react-router-dom";
import { ProgramBadge } from "@/pages/WeeklyJobs";

const FRESH_CLS = { recent: "text-volt", older: "text-amber-400", unknown: "text-neutral-500" };

/* One public job result. Dates are honest: "Posted" only when a real posting date exists; "Added" = when we found it. */
export function JobCard({ job, search }) {
  const j = job;
  return (
    <li className="p-4 flex flex-col md:flex-row md:items-start gap-3" data-testid={`roundup-job-${j.id}`}>
      <ProgramBadge program={j.program} label={j.program_label} />
      <div className="flex-1 min-w-0">
        <div className="heading text-lg leading-tight" data-testid={`job-title-${j.id}`}>{j.title}</div>
        <div className="text-sm text-neutral-300 mt-0.5" data-testid={`job-school-${j.id}`}>{j.program_name}</div>
        <dl className="mt-2 grid grid-cols-2 sm:grid-cols-3 gap-x-4 gap-y-1 text-xs">
          <Meta k="Role" v={j.role_label} /><Meta k="Level" v={j.level_label} /><Meta k="Location" v={j.location} />
          <Meta k="Date" v={j.posted_label} wide />
          <div className="col-span-2 sm:col-span-3"><dt className="sr-only">Open status</dt><dd className={FRESH_CLS[j.freshness]} data-testid={`job-fresh-${j.id}`}>{j.freshness_label} · Source: {j.source}</dd></div>
        </dl>
      </div>
      <Link to={`/jobs/${j.id}`} state={{ search }} data-testid={`roundup-view-${j.id}`} className="text-xs tracking-widest text-blaze underline underline-offset-4 shrink-0">VIEW OPENING →</Link>
    </li>
  );
}

function Meta({ k, v, wide }) {
  return (<div className={wide ? "col-span-2 sm:col-span-3" : ""}><dt className="inline text-neutral-500">{k}: </dt><dd className="inline text-neutral-200">{v}</dd></div>);
}
